<mat-sidenav-container fullscreen>
  <app-unsecured-sidenav></app-unsecured-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>